if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        // Check for the upsell checkbox in the purchase panel/parent container
        const purchasePanel = this.closest('.smarte-product-info__purchase-panel') || document;
        const upsellCheckbox = purchasePanel.querySelector('input[name="upsell_checkbox"]:checked, input[data-upsell-checkbox]:checked');
        const upsellVariantId = upsellCheckbox ? upsellCheckbox.value : null;

        const mainFormData = new FormData(this.form);
        const mainVariantId = mainFormData.get('id');
        
        // Find quantity from inside the form or from the linked external input
        let mainQuantity = parseInt(mainFormData.get('quantity')) || 1;
        const externalQty = document.querySelector(`input[name="quantity"][form="${this.form.id}"]`);
        if (externalQty) {
          mainQuantity = parseInt(externalQty.value) || 1;
        }

        // Build items array
        const items = [
          {
            id: mainVariantId,
            quantity: mainQuantity
          }
        ];

        // Add upsell product if selected
        if (upsellVariantId) {
          items.push({
            id: upsellVariantId,
            quantity: 1
          });
        }

        const sectionsToRender = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];
        
        const payload = {
          items: items,
          sections: sectionsToRender,
          sections_url: window.location.pathname
        };

        try {
          const response = await fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(payload)
          });

          const data = await response.json();

          if (data.status) {
            this.handleErrorMessage(data.description || data.message);
            this.error = true;
            return;
          }

          this.error = false;

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // Publish global cart update event for Dawn subscribers
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            await publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: mainVariantId,
              cartData: data,
            });
          }

          // Open and render cart drawer/notification
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(data);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(data);
          }
        } catch (e) {
          console.error(e);
          this.handleErrorMessage(e.message || 'Error updating cart');
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}